<canvas #canvas (mousemove)="mouseInteraction($event)"></canvas>
<wm-magnifer-glass
  [isVisible]="isMagnifierVisible"
  [imageUrl]="canvasImageBlobUrl"
  [x]="magX" [y]="magY"
  [dx]="magDx" [dy]="magDy"
  [containerWidth]="magContW" [containerHeight]="magContH"
></wm-magnifer-glass>
<wm-contrast-tooltip-view
  [isVisible]="isTooltipVisible"
  [analysisItem]="tooltipAnalysisItem"
  [canvas]="canvas"
  [imageDataUrl]="imageDataUrl">
</wm-contrast-tooltip-view>
<div class="btn-grp" (mouseenter)="revealBtnGrp()" (mouseleave)="collapseBtnGrp()" [ngClass]="{'btn-grp-expanded': areBtnsVisible, 'btn-grp-collapsed': !areBtnsVisible}">
  @if (!areBtnsVisible) {
    <fa-icon icon="expand"></fa-icon>
  }
  @if (areBtnsVisible) {
    <div>
      <div class='checkbox-row'>
        <p-checkbox class="checkbox" (onChange)="drawImageAndAnalysis()" [(ngModel)]="arePassedVisible" [binary]="true" inputId="passed"></p-checkbox>
        <label for="passed">Highlight passed cases</label>
      </div>
      <div class="checkbox-row">
        <p-checkbox class="checkbox" (onChange)="drawImageAndAnalysis()" [(ngModel)]="areFailedVisible" [binary]="true" inputId="failed"></p-checkbox>
        <label for="failed">Highlight failed cases</label>
      </div>
      <div class="checkbox-row">
        <p-checkbox class="checkbox" (onChange)="handleMagnifierVisibilityChange()" [(ngModel)]="isMagnifierVisible" [binary]="true" inputId="magnifier"></p-checkbox>
        <label for="magnifier">Show magnifier (M)</label>
      </div>
    </div>
  }
</div>
